import { defineStore } from 'pinia'
import useGet from '../core/composables/api/useGet'
import { AnnouncementType, type Announcement } from '../core/components/announcement/announcement'
import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'

export const useNotificationStore = defineStore('notifications', () => {
  const { data: allAnnouncements, load: loadAnnouncements } = useGet<Announcement[]>(
    'notifications/announcements',
  )

  const hiddenAnnouncementIds = useLocalStorage<string[]>('hidden-announcements', [])
  const animatedAnnouncementIds = useLocalStorage<string[]>('animated-announcements', [])


  const news = computed(() => {
    if (!allAnnouncements.value) {
      return undefined
    }

    const visibleAnnouncements = allAnnouncements.value?.filter(
      (announcement) =>
        announcement.type == AnnouncementType.News &&
        !hiddenAnnouncementIds.value.includes(announcement.id),
    )

    if (visibleAnnouncements.length == 0) {
      return undefined
    }

    return {
      ...visibleAnnouncements[0],
      animated: animatedAnnouncementIds.value.includes(visibleAnnouncements[0].id),
    }
  })

  const maintenance = computed(() => {
    if (!allAnnouncements.value) {
      return undefined
    }

    const visibleAnnouncements = allAnnouncements.value?.filter(
      (announcement) =>
        announcement.type == AnnouncementType.Maintenance &&
        !hiddenAnnouncementIds.value.includes(announcement.id),
    )

    if (visibleAnnouncements.length == 0) {
      return undefined
    }

    return {
      ...visibleAnnouncements[0],
      animated: animatedAnnouncementIds.value.includes(visibleAnnouncements[0].id),
    }
  })

  const hide = async (id: string) => {
    if (!hiddenAnnouncementIds.value.includes(id)) {
      hiddenAnnouncementIds.value.push(id)
    }
  }

  const animated = async (id: string) => {
    if (!animatedAnnouncementIds.value.includes(id)) {
      animatedAnnouncementIds.value.push(id)
    }
  }

  const initialize = async () => {
    await loadAnnouncements()
  }

  return {
    news,
    maintenance,
    animated,
    hide,
    initialize,
  }
})
